import { Base } from 'app/components/ui/Base'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'
import { Image } from 'app/components/ui/Image'
import { LoadingSpinner } from 'app/components/ui/LoadingSpinner'
import { Title } from 'app/components/ui/Title'
import { useAuth } from 'app/contexts/AuthenticationProvider'
import { useLayout } from 'app/contexts/LayoutProvider'
import { useConfirmUser } from 'app/queries/confirmUser'
import { protectedRoutes, routes } from 'app/routing/routes'
import { parse } from 'query-string'
import React, { useEffect, useLayoutEffect } from 'react'
import { useErrorHandler } from 'react-error-boundary'
import { Redirect, useLocation } from 'react-router-dom'
import styled from 'styled-components'

export const UserConfirm = (): JSX.Element => {
  const { user } = useAuth()

  const { updateLayoutData } = useLayout()

  const { mutate: confirmUser, isLoading, isSuccess, error } = useConfirmUser()

  useErrorHandler(error)

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Conferma utente',
    })
  }, [updateLayoutData])

  // Get confirmation token from url
  const { search } = useLocation()

  const queryObject = parse(search)
  const confirmation_token = queryObject['confirmation_token']
    ? `${queryObject['confirmation_token']}`
    : undefined

  useEffect(() => {
    if (confirmation_token) {
      confirmUser({ confirmation_token: confirmation_token })
    }
  }, [confirmUser, confirmation_token])

  if (!confirmation_token) {
    return <Redirect to={routes.login.path} />
  }

  return (
    <Base>
      <UserConfirmContainer>
        {isLoading && <LoadingSpinner />}
        {isSuccess && (
          <div>
            <Image
              src='https://res.cloudinary.com/estra/image/upload/v1628512610/estra20dev/sponsor/thumb_up.svg'
              alt='thumb_up'
            ></Image>
            <Title size={3} mt={3} mb={3}>
              La tua mail è stata confermata
            </Title>
            <Button
              to={!user ? routes.login.path : protectedRoutes.dashboard.path}
            >
              {!user ? 'Vai alla login' : 'Vai alla home'}
            </Button>
          </div>
        )}
      </UserConfirmContainer>
    </Base>
  )
}

const UserConfirmContainer = styled(Container)`
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;
`
